/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
var waitForEl = function(selector, callback) {
  if (jQuery(selector).length) {
    callback();
  } else {
    setTimeout(function() {
      waitForEl(selector, callback);
    }, 100);
  }
};
$(window).scroll(function() {
    
});

$(window).on('load', function() {
    
});
$(document).ready(function() {
	waitForEl(".product-afterpay-payment-methods-wrapper .afterpay-paragraph .afterpay-link", function() {
		$(".product-afterpay-payment-methods-wrapper .afterpay-paragraph").on("click", function(e) {
			e.preventDefault();
			$(".product-afterpay-payment-methods-wrapper .afterpay-paragraph .afterpay-link")[0].click();
		});
	});
	$(".open-zip-payment-popup").on("click", function(e){
		e.preventDefault();
      	var $iframe = $(".zip-widget__iframe").contents();
     	$("body", $iframe).trigger("click");
    });
	$(".product-block-custom-tabs .tabs-lists li a").on("click", function(e){
		e.preventDefault();
		if($(this).parent("li").hasClass("active")) {

		} else {
			var currentId = $.trim($(this).attr("data-href"));
			if(typeof currentId != "undefined" && currentId != null && currentId != "") {
				$(".custom-single-tab-content").css("height", 0+"px");
				$(currentId).css("height", "auto");
				$(".product-block-custom-tabs ul li").removeClass("active");
				$(this).parent("li").addClass("active");
			}
		}
	});
	
	// if($(".frequenlty-bought-products.custom-frequenlty-cartridge-products .product-item").length > 0) {
	// 	$('.frequenlty-bought-products.custom-frequenlty-cartridge-products').slick({
	// 		infinite: false,
	// 		slidesToShow: 2,
	// 		slidesToScroll: 1,
	// 		arrows: false,
	// 		dots: true,
	// 		responsive: [
	// 			{
	// 				breakpoint: 640,
	// 				settings: {
	// 					slidesToShow: 1
	// 				}
	// 			}
	// 		]
	// 	});
	// }
	// if($(".frequenlty-bought-products.custom-frequenlty-bought-products .product-item").length > 0) {
	// 	$('.frequenlty-bought-products.custom-frequenlty-bought-products').slick({
	// 		infinite: false,
	// 		slidesToShow: 2,
	// 		slidesToScroll: 1,
	// 		arrows: false,
	// 		dots: true,
	// 		responsive: [
	// 			{
	// 				breakpoint: 640,
	// 				settings: {
	// 					slidesToShow: 1
	// 				}
	// 			}
	// 		]
	// 	});
	// }
});

/* humm line above the Zip and Afterpay row (snippets/mwf-humm-line.liquid):
   shown only for prices inside the humm order limits (Theme settings > humm,
   passed in as data-min and data-max, in cents), and its pop-up quotes the
   current price (data-amount). Follows the variant (variant:changed) and,
   where add-ons change the total, the amount product-inclusions.js hands to
   Afterpay (afterpay:refresh). */
(function () {
  function update(cents) {
    if (!(cents >= 0)) { return; }
    document.querySelectorAll('[data-mwf-humm]').forEach(function (box) {
      var min = parseInt(box.getAttribute('data-min'), 10) || 0,
          max = parseInt(box.getAttribute('data-max'), 10) || Infinity,
          info = box.querySelector('[data-mwf-humm-info]');
      box.hidden = cents < min || cents > max || box.getAttribute('data-has-rate') === '0';
      if (info) { info.setAttribute('data-amount', cents); }
    });
  }
  /* Weekly amount for the chosen variant (snippets/mwf-pay-area.liquid
     data-rates: "variant id-price in cents" -> [weekly, months]). No line
     for this variant at this price: the box stays hidden. */
  function weekly(v) {
    document.querySelectorAll('[data-mwf-humm]').forEach(function (box) {
      var line = box.querySelector('[data-mwf-humm-line]'), rates = {};
      try { rates = JSON.parse(box.getAttribute('data-rates') || '{}'); } catch (err) { rates = {}; }
      var r = rates[v.id + '-' + v.price];
      box.setAttribute('data-has-rate', r ? '1' : '0');
      if (r && line) { line.innerHTML = 'As low as <b>$' + r[0] + '</b> per week, over ' + r[1] + ' repayments.'; }
    });
  }
  document.addEventListener('variant:changed', function (e) {
    var v = e.detail && e.detail.variant;
    if (v && typeof v.price === 'number') { weekly(v); update(v.price); }
  });
  document.addEventListener('afterpay:refresh', function () {
    var ap = document.getElementById('product-Afterpay-wrapper'), d = ap && parseFloat(ap.getAttribute('data-afterpay-amount'));
    if (d > 0) { update(Math.round(d * 100)); }
  });
}());


/* "Secure checkout" (snippets/mwf-pay-area.liquid): shows and hides the card
   logos. */
document.addEventListener('click', function (e) {
  var b = e.target.closest && e.target.closest('[data-mwf-pay-toggle]');
  if (!b) { return; }
  var p = document.getElementById(b.getAttribute('aria-controls')), open = b.getAttribute('aria-expanded') !== 'true';
  b.setAttribute('aria-expanded', open ? 'true' : 'false');
  if (p) { p.hidden = !open; }
});


/* humm highlight (snippets/mwf-pay-area.liquid): the (i) opens and closes a
   short note; a click elsewhere or Escape closes it. */
(function () {
  function closeAll(except) {
    document.querySelectorAll('[data-mwf-pay-i][aria-expanded="true"]').forEach(function (b) {
      if (b === except) { return; }
      b.setAttribute('aria-expanded', 'false');
      var p = document.getElementById(b.getAttribute('aria-controls'));
      if (p) { p.hidden = true; }
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-mwf-pay-i]');
    if (b) {
      var p = document.getElementById(b.getAttribute('aria-controls')), open = b.getAttribute('aria-expanded') !== 'true';
      closeAll(b);
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (p) { p.hidden = !open; }
      return;
    }
    if (!(e.target.closest && e.target.closest('.mwf-pay__pop'))) { closeAll(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeAll(); } });
}());


/* Product info card, desktop (assets/mwfs.css): shown in full, no scrollbar.
   A card that fits the window sticks under the header. A taller one is a
   sticky element whose pinned edge follows the scroll direction:
     down: top = window height - card height - 16, so it moves up with the
           page and the browser pins it once its bottom is in view;
     up:   bottom set so that it moves down with the page and is pinned once
           its top is back under the header.
   On a change of direction the spacer above the card (--mwf-space on the
   column) is set to where the card is now, so it carries on from there. All
   the moving and pinning is the browser's own sticky positioning. */
(function () {
  var card = document.querySelector('.product-block-list__item--info > .card--sticky');
  if (!card || !window.matchMedia) { return; }
  var col = card.parentElement, mq = window.matchMedia('(min-width: 1000px)');
  var GAP = 16, dir = 'down', lastY = window.scrollY, queued = false;

  function px(v) { return Math.round(v) + 'px'; }
  function headTop() {
    return (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 134) + GAP;
  }
  function clear() {
    col.style.removeProperty('--mwf-space');
    card.style.removeProperty('--mwf-top');
    card.style.removeProperty('--mwf-bottom');
  }
  // The spacer that puts the card at `at` (its top, in the window), kept
  // within its column.
  function spacer(at) {
    var cs = getComputedStyle(col), ms = getComputedStyle(card);
    var start = col.getBoundingClientRect().top + parseFloat(cs.paddingTop) + parseFloat(ms.marginTop);
    var room = col.clientHeight - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom) - card.offsetHeight - parseFloat(ms.marginTop) - parseFloat(ms.marginBottom);
    return Math.max(0, Math.min(at - start, room));
  }
  function edges(top, vh, h) {
    if (dir === 'down') {
      card.style.setProperty('--mwf-top', px(vh - GAP - h));
      card.style.setProperty('--mwf-bottom', 'auto');
    } else {
      card.style.setProperty('--mwf-top', 'auto');
      card.style.setProperty('--mwf-bottom', px(vh - top - h));
    }
  }
  function run(e) {
    queued = false;
    var y = window.scrollY, dy = e && e.type === 'scroll' ? y - lastY : 0;
    lastY = y;
    if (!mq.matches) { clear(); return; }
    var top = headTop(), vh = window.innerHeight, h = card.offsetHeight;
    if (h <= vh - top - GAP) { clear(); card.style.setProperty('--mwf-top', px(top)); return; }
    var r = card.getBoundingClientRect();
    if ((dy > 0 && dir === 'up') || (dy < 0 && dir === 'down')) {
      // Turning. A card that was pinned stood still during this scroll, so it
      // takes the step with the page now; one that was moving already has.
      var pinned = dir === 'down' ? Math.abs(r.bottom - (vh - GAP)) < 1 : Math.abs(r.top - top) < 1;
      col.style.setProperty('--mwf-space', px(spacer(r.top - (pinned ? dy : 0))));
      dir = dy > 0 ? 'down' : 'up';
    } else if (!e || e.type !== 'scroll') {
      col.style.setProperty('--mwf-space', px(spacer(r.top))); // resized: stay where it is
    }
    edges(top, vh, h);
  }
  function queue() {
    if (!queued) { queued = true; window.requestAnimationFrame(function () { run(); }); }
  }
  window.addEventListener('scroll', run, { passive: true });
  window.addEventListener('resize', queue);
  if (window.ResizeObserver) { new ResizeObserver(queue).observe(card); }
  run();
}());
